"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedStatusSummary = exports.getCurrentAssigneeName = exports.getSelectedRecommendationTypes = exports.summarizeRecommendationsPerStatus = exports.getRecommendationStatus = void 0;
var interfaces_1 = require("@hudled/interfaces");
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var pick_1 = __importDefault(require("lodash/pick"));
var baseStatusSummary = { actionedCount: 0, inProgressCount: 0, toActionCount: 0 };
var getRecommendationStatus = function (reco) {
    if (reco.status && [interfaces_1.RECOMMENDATIONS_STATUS.REJECTED, interfaces_1.RECOMMENDATIONS_STATUS.USED].includes(reco.status)) {
        return 'actioned';
    }
    if (reco.status === interfaces_1.RECOMMENDATIONS_STATUS.DEFERRED)
        return 'inProgress';
    return 'toAction';
};
exports.getRecommendationStatus = getRecommendationStatus;
var summarizeRecommendationsPerStatus = function (recommendations) {
    var statusSummary = __assign(__assign({}, baseStatusSummary), { byUserMap: {} });
    if (!recommendations) {
        return null;
    }
    recommendations.filter(function (r) { return !r.isSoftDelete; }).forEach(function (recommendation) {
        var assignee = recommendation.assignee || recommendation.defaultAssignee;
        var assigneeId = recommendation.assigneeId || recommendation.defaultAssigneeId;
        if (!assignee || !assigneeId)
            return;
        var recommendationStatus = (0, exports.getRecommendationStatus)(recommendation);
        if (!statusSummary.byUserMap[assigneeId]) {
            statusSummary.byUserMap[assigneeId] = __assign(__assign({}, baseStatusSummary), { assignee: assignee });
        }
        var statusCountField = "".concat(recommendationStatus, "Count");
        statusSummary.byUserMap[assigneeId][statusCountField] += 1;
        statusSummary[statusCountField] += 1;
    });
    statusSummary.byUser = (0, orderBy_1.default)(Object.values(statusSummary.byUserMap), ['toActionCount', 'inProgressCount', 'actionedCount'], ['desc', 'desc', 'desc']);
    return statusSummary;
};
exports.summarizeRecommendationsPerStatus = summarizeRecommendationsPerStatus;
var getSelectedRecommendationTypes = function (location) {
    var _a;
    var query = new URLSearchParams(location.search);
    return (_a = query.get('rec_types')) === null || _a === void 0 ? void 0 : _a.split(',').filter(Boolean);
};
exports.getSelectedRecommendationTypes = getSelectedRecommendationTypes;
var getCurrentAssigneeName = function (item) {
    var currentAssignee = item.assignee || item.defaultAssignee;
    return (currentAssignee === null || currentAssignee === void 0 ? void 0 : currentAssignee.firstName) || (currentAssignee === null || currentAssignee === void 0 ? void 0 : currentAssignee.displayName);
};
exports.getCurrentAssigneeName = getCurrentAssigneeName;
var getFormattedStatusSummary = function (statusSummary, ownersToFilterBy, statusMap) {
    if (ownersToFilterBy.length === 0) {
        return (0, pick_1.default)(statusSummary, ['actionedCount', 'inProgressCount', 'toActionCount']);
    }
    var partialSummary = { actionedCount: 0, inProgressCount: 0, toActionCount: 0 };
    ownersToFilterBy.forEach(function (userId) {
        Object.keys(statusMap).map(function (status) { return "".concat(status, "Count"); }).forEach(function (k) {
            var _a;
            partialSummary[k] += ((_a = statusSummary === null || statusSummary === void 0 ? void 0 : statusSummary.byUserMap[userId]) === null || _a === void 0 ? void 0 : _a[k]) || 0;
        });
    });
    return partialSummary;
};
exports.getFormattedStatusSummary = getFormattedStatusSummary;
